<template>
    <div class="">
        <ynav  title="批号查看说明"></ynav>
        <div class="shuoming bgb pad30">
            <p>翻开孩子的疫苗接种本，打开接种记录页，即可查看疫苗批号和生产厂家。</p>
            <p><img src="../assets/images/yimiao.png"></p>
            <p>
            <a class="chaxun" href="javascrpit:;" @click="$router.push({name:'Index'})">再次查询</a>
            </p>
        </div>
    </div>
</template>

<script>
import * as api from "../libs/api";
import  ynav from "../components/nav";

export default {
  components: {
    ynav
  },
};
</script>




// WEBPACK FOOTER //
// src/views/Guide.vue